import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import StepTwoComponent from "../components/StepTwoComponent";
import { getOrganizationService } from "services/settings";
import ToastrContent from "components/common/Toastr/Toastr";
import { toast } from "react-toastify";
import _ from "lodash";
import readXlsxFile from "read-excel-file";
import { getDirectoriesService } from "services/scanning";

const StepTwo = (props) => {
  const { changeStep, data, submitStepData, readOnly } = props;

  const [isFetchingOrganizations, setIsFetchingOrganizations] = useState(false);
  const [organizationData, setOrganizationData] = useState([]);
  const [filesTreeData, setFilesTreeData] = useState([]);

  const { t } = useTranslation();

  useEffect(() => {
    getOrganizationsData();
  }, []);

  const getOrganizationsData = async () => {
    setIsFetchingOrganizations(true);

    try {
      const response = await getOrganizationService();
      setOrganizationData(response);

      if (data.length) {
        const fetchedFilesTreeData = data.map((singleDepartment) => {
          let tenantId = "";
          let groupId = "";
          let departmentId = "";
          let files = [];

          response.organization.forEach((tenant) => {
            return tenant.groups.forEach((group) => {
              return group.departments.forEach((department) => {
                if (
                  department.departmentId === singleDepartment.orgDepartmentId
                ) {
                  tenantId = tenant.tenantId;
                  groupId = group.groupId;
                  departmentId = department.departmentId;

                  const departmentFiles = singleDepartment.directoryPath.map(
                    (path) => {
                      const pathNames = path.split("\\");
                      const filename = _.last(pathNames);
                      const smallPath =
                        pathNames.length > 3
                          ? `${pathNames[0]}\\...\\${
                              pathNames[pathNames.length - 2]
                            }\\${pathNames[pathNames.length - 1]}`
                          : path;

                      return {
                        name: filename,
                        path,
                        smallPath,
                        fullName: path
                      };
                    }
                  );

                  files = departmentFiles;
                }
              });
            });
          });

          if (tenantId && groupId && departmentId) {
            return {
              tenantId,
              groupId,
              departmentId,
              files,
            };
          }
        });

        setFilesTreeData(fetchedFilesTreeData);
      } else {
        const fileTreeData = {
          tenantId:
            response.organization && response.organization.length
              ? response.organization[0].tenantId
              : "",
          groupId: "",
          departmentId: "",
          files: [],
        };

        setFilesTreeData([fileTreeData]);
      }
    } catch (err) {
      console.log(err);
    }

    setIsFetchingOrganizations(false);
  };

  const setTreeTenantId = (treeIndex, id) => {
    const newTreeData = [
      {
        tenantId: parseInt(id),
        groupId: "",
        departmentId: "",
        files: [],
      },
    ];

    setFilesTreeData(newTreeData);
  };

  const setTreeGroupId = (treeIndex, id) => {
    let newTreeData = _.cloneDeep(filesTreeData);
    const selectedTreeData = newTreeData[treeIndex];
    const thisTenant = organizationData.organization.filter(
      (organization) => organization.tenantId === selectedTreeData.tenantId
    )[0];
    const thisTenantGroups = thisTenant ? thisTenant.groups : [];

    if (_.isNil(id) && thisTenantGroups.length) {
      newTreeData[treeIndex].groupId = parseInt(thisTenantGroups[0].groupId);
    } else {
      newTreeData[treeIndex].groupId = parseInt(id);
    }

    newTreeData[treeIndex].departmentId = "";

    if (!_.isNil(id) && id?.length === 0 && treeIndex > 0) {
      newTreeData.splice(treeIndex, 1);
    }

    setFilesTreeData(newTreeData);
  };

  const setTreeDepartmentId = (treeIndex, id) => {
    let newTreeData = _.cloneDeep(filesTreeData);
    const selectedTreeData = newTreeData[treeIndex];
    const thisTenant = organizationData.organization.filter(
      (organization) => organization.tenantId === selectedTreeData.tenantId
    )[0];
    const thisTenantGroup = thisTenant.groups.filter(
      (group) => group.groupId === selectedTreeData.groupId
    )[0];
    const thisTenantDepartments = thisTenantGroup
      ? thisTenantGroup.departments
      : [];

    if (_.isNil(id) && thisTenantDepartments.length) {
      newTreeData[treeIndex].departmentId = parseInt(
        thisTenantDepartments[0].departmentId
      );
    } else {
      newTreeData[treeIndex].departmentId = parseInt(id);
    }

    setFilesTreeData(newTreeData);
  };

  const setTreeNewFile = (treeIndex, filesDataArray) => {
    let newTreeData = _.cloneDeep(filesTreeData);

    filesDataArray.forEach((fileData) => {
      const { name, path, fullName, invalid } = fileData;

      const pathNames = path.split("\\");
      const smallPath =
        pathNames.length > 3
          ? `${pathNames[0]}\\...\\${pathNames[pathNames.length - 2]}\\${
              pathNames[pathNames.length - 1]
            }`
          : path;

      const fileEntry = { name, path, smallPath, fullName };
      if (invalid) fileEntry.invalid = true;

      newTreeData[treeIndex].files = [
        ...newTreeData[treeIndex].files,
        fileEntry,
      ];
    });

    setFilesTreeData(newTreeData);
  };

  const deleteTreeFile = (treeIndex, fileIndex) => {
    let newTreeData = _.cloneDeep(filesTreeData);
    newTreeData[treeIndex].files.splice(fileIndex, 1);

    setFilesTreeData(newTreeData);
  };

  const addTreeItem = (isDepartment) => {
    const tenantId = filesTreeData[0].tenantId;

    const currentTenant = organizationData?.organization?.filter(
      (tenant) => tenant.tenantId === tenantId
    )[0];
    const currentTenantGroups = currentTenant?.groups;
    const firstGroupId = currentTenantGroups[0]?.groupId;

    const currentGroup = currentTenantGroups?.filter(
      (group) => group.groupId === firstGroupId
    )[0];
    const currentGroupDepartments = currentGroup?.departments;
    const firstDepartmentId = currentGroupDepartments[0]?.groupId;

    const fileTreeData = {
      tenantId: filesTreeData[0].tenantId,
      groupId: firstGroupId,
      departmentId: isDepartment ? firstDepartmentId : "",
      files: [],
    };

    setFilesTreeData([...filesTreeData, fileTreeData]);
  };

  const uploadExcelDirectories = async (treeIndex, event) => {
    try {
      const file = event.target.files[0];
      if (!file) return;

      const format = _.last(file.name?.split("."));
      if (format !== "xlsx") throw new Error("Only .xlsx files are supported");

      const rows = await readXlsxFile(file, { sheet: 1 });

      // Extract paths: first column, skip header if present
      let paths = rows.map((row) => row[0]?.toString().trim()).filter(Boolean);
      if (paths[0]?.toLowerCase() === "verzeichnis") paths.shift();

      console.log(`[ExcelImport] File: ${file.name}`);
      console.log(`[ExcelImport] Paths read: ${paths.length}`);

      // Filter children: normalize to extended path format (\\?\), sort by length, accept only parents
      const toExtendedPath = (p) => {
        let s = p.replace(/\//g, "\\");
        if (s.startsWith("\\\\?\\")) return s;
        if (s.startsWith("\\\\")) return "\\\\?\\UNC\\" + s.slice(2);
        return "\\\\?\\" + s;
      };
      const normalized = paths.map(toExtendedPath);
      const withTrailing = normalized.map((p) =>
        p.endsWith("\\") ? p : p + "\\"
      );
      const sorted = [...withTrailing].sort((a, b) => a.length - b.length);

      const accepted = [];
      const discarded = [];

      sorted.forEach((path) => {
        const parent = accepted.find((a) => path.startsWith(a));
        if (parent) {
          discarded.push({
            path: path.slice(0, -1),
            reason: parent.slice(0, -1),
          });
          console.log(
            `[ExcelImport] Discarded (child of "${parent.slice(0, -1)}"): "${path.slice(0, -1)}"`
          );
        } else {
          accepted.push(path);
        }
      });

      // Remove trailing backslash for final result
      const finalPaths = accepted.map((p) => p.slice(0, -1));
      console.log(
        `[ExcelImport] Result: ${finalPaths.length} accepted, ${discarded.length} discarded`
      );
      console.log(`[ExcelImport] Final paths:`, finalPaths);

      if (!finalPaths.length) throw new Error("No valid paths found in Excel");

      // Validate paths against backend
      const validationResults = await Promise.allSettled(
        finalPaths.map((path) => getDirectoriesService(path))
      );

      const validPaths = [];
      const invalidPaths = [];

      validationResults.forEach((result, index) => {
        if (result.status === "fulfilled" && result.value?.hasAccess !== false) {
          validPaths.push(finalPaths[index]);
        } else {
          invalidPaths.push(finalPaths[index]);
        }
      });

      console.log(`[ExcelImport] Validation: ${validPaths.length} valid, ${invalidPaths.length} invalid`);
      if (invalidPaths.length) {
        console.log(`[ExcelImport] Invalid paths:`, invalidPaths);
      }

      if (!validPaths.length && !invalidPaths.length) throw new Error("No valid paths found in Excel");

      // Convert to the format expected by setTreeNewFile
      const filesArray = [
        ...validPaths.map((fullPath) => {
          const segments = fullPath.split("\\");
          const name = _.last(segments);
          return { name, path: fullPath, fullName: fullPath };
        }),
        ...invalidPaths.map((fullPath) => {
          const segments = fullPath.split("\\");
          const name = _.last(segments);
          return { name, path: fullPath, fullName: fullPath, invalid: true };
        }),
      ];

      setTreeNewFile(treeIndex, filesArray);

      const messageParts = [];
      if (validPaths.length) messageParts.push(`${validPaths.length} directories imported`);
      if (discarded.length) messageParts.push(`${discarded.length} subdirectories filtered out`);
      if (invalidPaths.length) messageParts.push(`${invalidPaths.length} directories not found on server`);

      toast(
        <ToastrContent
          type={invalidPaths.length ? "warning" : "success"}
          title={invalidPaths.length ? t("toastr_title_warning") : t("toastr_title_success")}
          message={messageParts.join(", ")}
        />,
        { progressClassName: `toastr-progress-bar ${invalidPaths.length ? "warning" : "success"}` }
      );
    } catch (err) {
      console.error("[ExcelImport] Error:", err);
      toast(
        <ToastrContent
          type="danger"
          title={t("toastr_title_error")}
          message={err?.message || JSON.stringify(err)}
        />,
        { progressClassName: "toastr-progress-bar danger" }
      );
    } finally {
      event.target.value = "";
    }
  };

  const submitData = () => {
    let changeStepValid = true;
    let repeatedFilePaths = false;
    let hasInvalidPaths = false;

    // Check if any field is missing or has invalid paths
    filesTreeData.forEach((fileTreeData) => {
      if (
        !fileTreeData.files.length ||
        !fileTreeData.tenantId ||
        !fileTreeData.groupId ||
        !fileTreeData.departmentId
      )
        changeStepValid = false;

      if (fileTreeData.files.some((file) => file.invalid))
        hasInvalidPaths = true;
    });

    // Check if there are any duplicate or children paths
    const directoriesArray = filesTreeData
      .map((rowData) => {
        return rowData.files.map((file) => `${file.path}\\`);
      })
      .flat(1);

    const duplicatedPaths =
      _.uniq(directoriesArray).length !== directoriesArray.length;
    const childrenPaths = directoriesArray.some((path, i) => {
      const arrayWithoutIndex = directoriesArray.filter((item, j) => i !== j);
      return arrayWithoutIndex.some((otherPath) => otherPath.includes(path));
    });

    if (duplicatedPaths || childrenPaths) {
      repeatedFilePaths = true;
    }

    if (hasInvalidPaths && changeStepValid && !repeatedFilePaths) {
      const invalidCount = filesTreeData.reduce(
        (count, tree) => count + tree.files.filter((f) => f.invalid).length,
        0
      );

      const confirmed = window.confirm(
        `${invalidCount} ${t("excel_import_confirm_remove", "directories were not found on the server and will be removed. Continue?")}`
      );

      if (confirmed) {
        const cleanedData = filesTreeData.map((tree) => ({
          ...tree,
          files: tree.files.filter((f) => !f.invalid),
        }));
        setFilesTreeData(cleanedData);

        const hasValidFiles = cleanedData.every((tree) => tree.files.length > 0);
        if (hasValidFiles) {
          submitStepData(cleanedData, 2);
          changeStep(3);
        } else {
          toast(
            <ToastrContent
              type="danger"
              title={t("toastr_title_error")}
              message={t("toastr_wizard_step2_error_message")}
            />,
            { progressClassName: "toastr-progress-bar danger" }
          );
        }
      }
      return;
    }

    if (changeStepValid && !repeatedFilePaths) {
      submitStepData(filesTreeData, 2);
      changeStep(3);
    } else {
      let error = t("toastr_wizard_step2_error_message");
      if (repeatedFilePaths) error = t("toastr_wizard_step2_error_message_2");

      toast(
        <ToastrContent
          type="danger"
          title={t("toastr_title_error")}
          message={error}
        />,
        {
          progressClassName: "toastr-progress-bar danger",
        }
      );
    }
  };

  return (
    <StepTwoComponent
      isFetchingOrganizations={isFetchingOrganizations}
      submitData={submitData}
      organizationData={organizationData}
      filesTreeData={filesTreeData}
      setTreeTenantId={setTreeTenantId}
      setTreeGroupId={setTreeGroupId}
      setTreeDepartmentId={setTreeDepartmentId}
      setTreeNewFile={setTreeNewFile}
      deleteTreeFile={deleteTreeFile}
      addTreeItem={addTreeItem}
      uploadExcelDirectories={uploadExcelDirectories}
      readOnly={readOnly}
    />
  );
};

export default StepTwo;
